import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './PaginaInicio.css';
import './PaginaCertificado.css';
import Cabecera from '../Others/Cabecera';
import PiePagina from '../Others/PiePagina';
import BarraSuperior from '../Others/BarraSuperior';
import BarraInferior from '../Others/BarraInferior';
import {
  certificateApi,
  certificateDownloadUrl,
} from '../../services/certificateApi';
import { useData } from './DataContext';

const DownloadIcon = () => (
  <svg aria-hidden="true" viewBox="0 0 24 24">
    <path d="M12 3v12m0 0 5-5m-5 5-5-5M5 21h14" />
  </svg>
);

const CertificateIcon = () => (
  <svg aria-hidden="true" viewBox="0 0 24 24">
    <path d="M7 3h7l5 5v7M14 3v5h5M8 13h6M8 17h4" />
    <path d="M6 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8" />
    <path d="m18 17 .8 1.6 1.7.3-1.2 1.3.3 1.8-1.6-.8-1.6.8.3-1.8-1.2-1.3 1.7-.3L18 17Z" />
  </svg>
);

export const PaginaCertificado = () => {
  const { data } = useData();
  const [certificates, setCertificates] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const loadCertificates = async () => {
      setLoading(true);
      try {
        const items = await certificateApi.listMine(data.matricula);
        if (active) {
          setCertificates(Array.isArray(items) ? items : []);
          setError('');
        }
      } catch (requestError) {
        if (active) {
          setCertificates([]);
          setError(
            'No pudimos cargar tus constancias. Intenta nuevamente más tarde.',
          );
        }
      } finally {
        if (active) setLoading(false);
      }
    };

    if (data?.matricula) {
      loadCertificates();
    } else {
      setCertificates([]);
      setLoading(false);
    }
    return () => {
      active = false;
    };
  }, [data?.matricula]);

  return (
    <div className="contenedor-pagina">
      <Cabecera
        contenidosuperior={<BarraSuperior />}
        contenidoInferior={<BarraInferior />}
      />

      <main className="constancias-pagina">
        <section
          className="constancias-panel"
          aria-labelledby="constancias-titulo"
        >
          <header className="constancias-encabezado">
            <div>
              <span className="constancias-etiqueta">
                Documentos académicos
              </span>
              <h1 id="constancias-titulo">Mis constancias</h1>
              <p>Consulta y descarga las constancias disponibles.</p>
            </div>
            <div className="constancias-resumen">
              <strong>{certificates.length}</strong>
              <span>
                {certificates.length === 1
                  ? 'constancia disponible'
                  : 'constancias disponibles'}
              </span>
            </div>
          </header>

          {error && (
            <div
              className="constancias-mensaje constancias-mensaje-error"
              role="alert"
            >
              {error}
            </div>
          )}

          {loading ? (
            <div className="constancias-estado" aria-live="polite">
              <span className="constancias-cargador" />
              <strong>Cargando constancias</strong>
              <p>Estamos consultando tus documentos disponibles.</p>
            </div>
          ) : certificates.length === 0 ? (
            <div className="constancias-estado constancias-vacio">
              <span className="constancias-estado-icono">
                <CertificateIcon />
              </span>
              <strong>Aún no tienes constancias disponibles</strong>
              <p>
                Cuando se genere una constancia, aparecerá en esta sección.
              </p>
            </div>
          ) : (
            <div className="constancias-lista">
              {certificates.map((certificate) => (
                <article
                  className="constancia-card"
                  key={certificate.source + '-' + certificate.id}
                >
                  <span className="constancia-icono">
                    <CertificateIcon />
                  </span>
                  <div className="constancia-informacion">
                    <span className="constancia-tipo">
                      {certificate.source === 'legacy'
                        ? 'Documento heredado'
                        : 'Constancia académica'}
                    </span>
                    <h2 title={certificate.name}>{certificate.name}</h2>
                    {certificate.training && <p>{certificate.training}</p>}
                    {certificate.class_name && (
                      <p>
                        Clase <strong>{certificate.class_name}</strong>
                      </p>
                    )}
                  </div>
                  <div className="constancia-acciones">
                    {certificate.validation_token && (
                      <Link
                        className="boton-validar-certificado"
                        to={
                          '/validar-constancia/' +
                          encodeURIComponent(certificate.validation_token)
                        }
                      >
                        Validar
                      </Link>
                    )}
                    <a
                      className="boton-descargar-certificado"
                      href={certificateDownloadUrl(certificate.download_url)}
                    >
                      <DownloadIcon />
                      Descargar
                    </a>
                  </div>
                </article>
              ))}
            </div>
          )}
        </section>
      </main>

      <PiePagina imagenSrc={require('../Assets/piepagina.jpg')} />
      <footer>Grupo Derecho & Progreso &copy; 2024</footer>
    </div>
  );
};
